
import { useEffect, useState } from 'react';
import autofit from 'autofit.js';

import Intro from './module/Intro';
import Control from './module/Control';
import Warning from './module/Warning';
import Detail from './module/Detail';
import Weather from './module/Weather';
import Statistics from './module/Statistics';
import Event from './module/Event';
import Clock from './components/Clock';

import { request } from './utils/request';

import './App.css';
import { isEmpty } from 'lodash';

const App = () => {
  const [introData, setIntroData] = useState({});
  const [houseData, setHouseData] = useState([]);
  const [outdoorData, setOutdoorData] = useState({});

  useEffect(() => {
    autofit.init({
      dh: 1080,
      dw: 1920,
      el:"#root",
      resize: true
    }, false) // 可关闭控制台运行提示输出
  }, [])

  useEffect(() => {
    getIntroData();
  }, [])

  const getIntroData = async () => {
    const res = await request('info');
    setIntroData(res.park);
    setHouseData(res.houses.splice(0, 3));
  }

  return (
    <div className="App">
      <div className="header">
        <span className="days">{introData.days} 天</span>
        <Clock />
      </div>
      <div className="container">
        <div className="left">
          <Intro desc={introData.desc} />
          <Control houses={houseData} />
          <Warning />
        </div>
        <div className="center">
          <Detail houses={houseData} setData={setOutdoorData} />
        </div>
        <div className="right">
          {!isEmpty(houseData) && <Weather hid={houseData[0].hid} /> }
          <Statistics data={outdoorData} />
          <Event />
        </div>
      </div>
      {/* <div className='icp-code'>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target='_blank' rel="noreferrer">
          <img src="https://www.qingcloud.com/static/assets/images/ghs.png" alt='' />
          京ICP备2023007506号-1
        </a>
      </div> */}
    </div>
  );
}

export default App;
